export * from "@/components/article/dictsys/inflectionSchemes/labels";

export const casusLabels = {
  indicative: "Indicatif",
  perfect_tenses: "Formes composées",
  subjunctive: "Subjonctif",
  conditional: "Conditionnel",
  imperative: "Impératif"
};

export const tenseLabels = {
  present: "Présent",
  imperfect: "Imparfait",
  future: "Futur simple",
  past: "Passé",
  present_perfect: "Passé composé",
  past_perfect: "Plus-que-parfait",
  future_perfect: "Futur antérieur"
};
